import { AbstractInterface } from './AbstractInterface';
import { EVENT_HANDLER_TYPES } from '../constants';
import { EventHandler } from '../navigator-services';
import { keepAliveService} from '../../../../service/keep-alive';

export class KeepAlive extends AbstractInterface {

  /*
   * @param {Function} [success] Success callback
   * @param {Function} [error] Error callback
   *
   * @return {Promise} Promise of the request
   */
  public static call(success?: (value: any) => void, error?: (error: any) => void): Promise<any> {
    return keepAliveService.doRequest()
      .then(success, error);
  }

  public static run(): void {
    const successCallback = (response: any) => {
      EventHandler.trigger(EVENT_HANDLER_TYPES.KEEPALIVE_SUCCEEDED,
        (response && response.status ? response.status : null));
    };
    const failCallback = (response: any) => {
      EventHandler.trigger(EVENT_HANDLER_TYPES.KEEPALIVE_FAILED, response.status);
    };

    keepAliveService.start(successCallback, failCallback);
  }

  public static stop(): void {
    keepAliveService.stop();
  }

}
